<div class="create-configuration-container">
  <div *ngIf="!isLoaded">
    <app-loader></app-loader>
  </div>
  <div class="create-configuration-form" [ngClass]="{ 'create-configuration-form-loading': !isLoaded }">
    <div
      *ngIf="
        (modalFields[configFieldIndex]?.system_name === 'phone' && !modalFields[configFieldIndex]?.values?.length) ||
        (modalFields[configFieldIndex]?.system_name === 'ppi' && !modalFields[configFieldIndex]?.values?.length); else showOtherFields">
      <div class="no-promotions-added" *ngIf="!canCreateNumberConfig && modalFields[configFieldIndex]?.system_name !== 'ppi'; else createConfig">
        <app-join-program-alert
          [buttonText]="isPromotionPending ? '' : 'add_promotion'"
          [containerText]="{withTranslation: true, text: isPromotionPending ? 'application_waiting_for_acceptance' : 'no_promotions_text'}"
          (openModal)="open('', 'view_translations.add_promotion_method', 'add_promotion')">
        </app-join-program-alert>
      </div>
      <ng-template #createConfig>
        <app-add-general-config-first
          [containerIcon]="isCreatePPIConfig? 'link' : 'phone'"
          [isAvailable]="true"
          [urlConfigurationDefined]="true"
          [text]="isCreatePPIConfig ? 'add_direct_link_first' : 'add_number_first'"
          [buttonText]="isCreatePPIConfig ? 'add_direct_link' : 'add_number'"
          (emitAddConfiguration)="open('', ('view_translations.' + (isCreatePPIConfig ? 'add_direct_link' : 'assign_ivr_number')), (isCreatePPIConfig ? 'create_direct_link' : 'assign_number'))">
        </app-add-general-config-first>
      </ng-template>
    </div>
    <ng-template #showOtherFields>
      <ng-container *ngFor="let field of modalFields, index as i">
        <app-select-configuration-container
          *ngIf="field.system_name === 'phone' || field.system_name === 'ppi'"
          [fieldInfo]="field"
          [submitted]="submitted"
          (emitValue)="getValue($event)"
          [canCreateNumberConfig]="canCreateNumberConfig">
        </app-select-configuration-container>
        <!-- <h2
          *ngIf="field.system_name === 'fbtitle'"
          class="facebook-title">
          {{ 'view_translations.facebook' | translate }}
        </h2> -->
        <app-text-input
          [showAutofocus]="modalType?.includes('link') ? i === 0 : i === 1"
          *ngIf="field.type === 'text'"
          [fieldInfo]="field"
          [submitted]="submitted"
          (emitValue)="getValue($event)"
          [configurationData]="modalFields"
          [validators]="checkValidators(field.system_name ?? '')"
          [placeholder]="( field.system_name === 'fbimg' || field.system_name === 'image' ) ? 'type_img_url_address' : ''">
        </app-text-input>
        <app-textarea-input
          *ngIf="field.type === 'textarea'"
          [fieldInfo]="field"
          [submitted]="submitted"
          (emitValue)="getValue($event)"
          [configurationData]="modalFields">
        </app-textarea-input>
        <app-select-input
          (emitValue)="getValue($event)"
          *ngIf="field.type === 'domain' || field.type === 'landings_to_promotion'"
          [configurationData]="modalFields"
          [fieldInfo]="$any(field)"
          [submitted]="submitted">
        </app-select-input>
        <app-radio-input
          (emitValue)="getValue($event)"
          *ngIf="field.type === 'radio'"
          [configurationData]="modalFields"
          [fieldInfo]="field"
          [submitted]="submitted">
        </app-radio-input>
        <div *ngIf="(field.type)?.includes('img')" class="choose-image">
          <ng-container *ngFor="let name of field.translations">
            <h5 for="configuration-name" class="label-name" *ngIf="name.lang === panelLanguage">{{ name.label }}</h5>
          </ng-container>
          <div class="image-wrapper" (click)="open('', 'view_translations.choose_download_ppi_button', 'choose_button', $any(field.values))">
            <img class="button-image" [src]="$any(field.values?.[downloadButtonImageID]).image" />
          </div>
        </div>
      </ng-container>
      <div *ngIf="!directLinksConfig && !isCreatePPIConfig && (isAddModal || duplicateModal)" class="checkbox-container">
        <app-global-checkbox
          [submitted]="submitted"
          [required]="true"
          [text]="'i_accept'"
          [checked]="fieldsToSend.terms ? true : false"
          (emitChange)="getValue({ system: 'terms', value: $any($event) })"
          [disabled]="false">
          <a (click)="handleRegulations()" class="regualtions-text"> {{ 'view_translations.regulations' | translate }} </a>
        </app-global-checkbox>
      </div>
      <div class="create-configuration-button-container" *ngIf="showEditButton || isAddModal || duplicateModal">
        <button class="create-configuration-button" (click)="verifyForm()">
          <span>
            <nb-icon class="plus-icon" icon="plus" pack="icomoon" *ngIf="isAddModal"></nb-icon>
            {{ 'view_translations.' + ( isAddModal || duplicateModal ? 'add_configuration' : 'edit_configuration_modal' ) | translate }}
          </span>
        </button>
      </div>
    </ng-template>
  </div>
</div>
